"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LaunchDarklyWidget = LaunchDarklyWidget;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable */
/* TODO: fix ALL linting errors as some may call out code smells */
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const classnames_1 = __importDefault(require("classnames"));
const useFlagOverrides_1 = require("./hooks/useFlagOverrides");
const launch_darkly_widget_module_scss_1 = __importDefault(require("./launch-darkly-widget.module.scss"));
const ApplyButton_1 = require("./partials/ApplyButton/ApplyButton");
const FlatListApi_1 = require("./partials/FlagListApi/FlatListApi");
const AdvancedActions_1 = require("./partials/AdvancedActions/AdvancedActions");
function LaunchDarklyWidget({ flagApiUrl, tokenApiUrl, overridesParam, bypassCacheParam, advanced }) {
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const [isAdvanced, setIsAdvanced] = (0, react_1.useState)(false);
    const [overrides, setFlagOverride] = (0, useFlagOverrides_1.useFlagOverrides)();
    const handleHeaderClick = (event) => {
        event && event.preventDefault();
        setIsOpen(!isOpen);
    };
    const handleSettingsClick = (event) => {
        event && event.stopPropagation();
        if (!isOpen) {
            setIsOpen(true);
        }
        setIsAdvanced(!isAdvanced);
    };
    const widgetClasses = (0, classnames_1.default)(launch_darkly_widget_module_scss_1.default.launchDarklyWidget, {
        [launch_darkly_widget_module_scss_1.default['is-open']]: isOpen
    });
    const titleClasses = (0, classnames_1.default)(launch_darkly_widget_module_scss_1.default.launchDarklyWidget__header, {
        [launch_darkly_widget_module_scss_1.default['launchDarklyWidget__header--withIcon']]: advanced
    });
    const widgetTitle = advanced ? 'Site Config' : 'Launch Darkly';
    const actionProps = {
        tokenApiUrl,
        overridesParam,
        bypassCacheParam,
        isVisible: isAdvanced
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: widgetClasses, children: [(0, jsx_runtime_1.jsxs)("div", { className: titleClasses, role: "button", onClick: handleHeaderClick, onKeyDown: handleHeaderClick, tabIndex: 0, children: [advanced && (0, jsx_runtime_1.jsx)("span", { className: launch_darkly_widget_module_scss_1.default.settingsIcon, title: "Advanced", onClick: handleSettingsClick, children: "settings" }), widgetTitle] }), (0, jsx_runtime_1.jsx)("div", { className: launch_darkly_widget_module_scss_1.default.launchDarklyWidget__body, children: (0, jsx_runtime_1.jsx)("div", { className: "angryToddWidget__list", children: (0, jsx_runtime_1.jsx)(FlatListApi_1.FlagListApi, { overrides: overrides, setFlagValue: setFlagOverride, flagApiUrl: flagApiUrl }) }) }), (0, jsx_runtime_1.jsx)(ApplyButton_1.ApplyButton, { overrides: overrides }), advanced && (0, jsx_runtime_1.jsx)(AdvancedActions_1.AdvancedActions, { ...actionProps })] }));
}
LaunchDarklyWidget.propTypes = {
    /** Expose advanced settings */
    advanced: prop_types_1.default.bool,
    /** The url used to both get feature flag data and force into tests */
    flagApiUrl: prop_types_1.default.string.isRequired,
    /** The url used to generate a token as the viewer request event does in cloud front */
    tokenApiUrl: prop_types_1.default.string,
    /** The query param used to clear override cookie. Pass `null` if you want to hide this option */
    overridesParam: prop_types_1.default.string,
    /** The query param used to bypass CF cache. Pass `null` if you want to hide this option */
    bypassCacheParam: prop_types_1.default.string
};
//# sourceMappingURL=launch-darkly-widget.js.map